module.exports = __webpack_public_path__ + "static/media/logo.a5469e0f.svg";